<template>
  <div v-if="projID && proj" class="animated fadeIn">
    <div class="tab-style-management" v-if="cropperiod_edit_id == undefined">
      <b-tabs
        v-model="tabIndex"
        class="info-tabs"
        content-class="info-tab-content"
      >
        <!-- 建立新期作的按鈕 -->
        <b-tab
          v-if="cropperiod_list_key == 'cropperiods'"
          button-id="create-new-tab"
          class="info-tab"
          :title="'+ ' + $t('menu.new_cropping_season')"
          title-link-class="info-tab-link-new"
        ></b-tab>
        <!-- 非 farming 狀態不顯示建立新期作的按鈕 -->
        <b-tab v-else></b-tab>

        <!-- 期作資訊 -->
        <b-tab
          class="info-tab"
          v-for="(CP, idx_cp) in proj[cropperiod_list_key]"
          :key="idx_cp"
          :title="idx_cp + 1 + ' - ' + CP.name"
        ></b-tab>
      </b-tabs>
    </div>

    <!-- 期作資訊 -->
    <div class="container-fluid">
      <b-row>
        <!-- 建立新期作時，隱藏更新期作圖片 & 期作 boundary 的區塊 -->
        <b-col md="2" v-if="tab_create"></b-col>
        <b-col md="4" v-else>
          <!-- 上傳期作 圖片 -->
          <div class="proj-toolbox-area text-center">
            <!-- 期作 圖片 -->
            <div class="toolbox-pic" v-show="!edit.pic">
              <h4 class="card-title agri-color" v-text="cropInfo.name"></h4>
              <div
                class="cropperiod-img cover-bg"
                alt="Cropping Season Photo"
                :style="
                  $tools.style.imgCover(
                    $config.checkURL('cropperiod', pic_preview)
                  )
                "
              ></div>
            </div>

            <div class="toolbox-pic-edit" v-show="pic_files.length && edit.pic">
              <vue-cropper
                v-if="pic_files.length && edit.pic"
                ref="cropper"
                :src="pic_preview"
                :info="true"
                :aspectRatio="1.5"
                :fixedBox="true"
                :centerBox="true"
                :canScale="true"
                alt="Theme Image"
              >
              </vue-cropper>
            </div>

            <div class="proj-toolbox">
              <div class="proj-toolbox-title">
                <i class="fa fa-wrench block-text"></i
                >{{ $t("menu.toolbox") }}：{{ $t("n.cropping_season") }}
                {{ $t("menu.picture") }}
              </div>
              <div class="proj-toolbox-body">
                <file-upload
                  extensions="gif,jpg,jpeg,png,webp"
                  accept="image/png,image/gif,image/jpeg,image/webp"
                  :size="1024 * 1024 * 2"
                  :drop="true"
                  name="pic"
                  class="btn btn-success btn-upload"
                  v-model="pic_files"
                  @input-filter="image_inputFilter"
                  @input-file="check_inputFile_pic"
                  :disabled="uploading"
                  ref="upload"
                >
                  <i class="fa fa-plus"></i>
                  {{ $t("menu.upload_image") }}
                </file-upload>
                <button
                  type="button"
                  class="btn btn-secondary btn-upload"
                  @click.prevent="reset_imagePreview(false)"
                  :disabled="uploading"
                >
                  <i class="fa fa-close"></i> {{ $t("menu.cancel") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-danger btn-upload btn-red"
                  @click.prevent="upload_image('pic', pic_files)"
                  :disabled="!Boolean(pic_files[0]) || uploading"
                >
                  <i class="fa fa-upload"></i> {{ $t("menu.save_changes") }}
                </button>
              </div>
            </div>
          </div>
          <!-- end 期作 PIC -->

          <!-- 上傳期作 boundary -->
          <div class="proj-toolbox-area text-center" v-if="cropInfo.name">
            <div class="proj-toolbox">
              <div class="proj-toolbox-title">
                <i class="fa fa-wrench block-text"></i
                >{{ $t("menu.toolbox") }}：{{ this.$t("n.cropping_season") }}
                {{ this.$t("menu.map_boundary") }}
              </div>
              <div class="proj-toolbox-body">
                <b-form-file
                  v-model="KML_file"
                  accept=".kml"
                  placeholder="Choose a file..."
                  ref="fileinput_KML"
                ></b-form-file>

                <b-button
                  variant="success"
                  class="px-4 btn-upload"
                  @click="upload_files('KML')"
                  :disabled="!Boolean(KML_file) || uploading"
                >
                  <i class="fa fa-plus"></i>{{ $t("menu.upload") }}
                </b-button>
                <button
                  type="button"
                  class="btn btn-secondary btn-upload"
                  @click.prevent="reset_files('KML')"
                  :disabled="uploading"
                >
                  <i class="fa fa-close"></i> {{ $t("menu.cancel") }}
                </button>
              </div>
              <div class="proj-toolbox-footer">
                <a href="https://www.doogal.co.uk/polylines.php" target="blank"
                  ><i class="fa fa-object-ungroup block-text"></i>
                  {{ $t("menu.online_map_boundary_editor") }} (KML Files)</a
                >
              </div>
            </div>
          </div>
          <!-- end 期作 boundary -->

          <!-- 期作公開儀錶板開關 -->
          <div class="proj-toolbox-area text-center" v-if="cropperiod_detail">
            <PublicToolsSwitch
              :cropperiodID="cpID"
              :projectDetail="project_detail"
              :cropperiodDetail="cropperiod_detail"
              @update="getCropperiod(cpID)"
            ></PublicToolsSwitch>
          </div>
          <!-- end 期作計算開關 Agent Switch -->

          <!-- 期作計算開關 Agent Switch -->
          <div class="proj-toolbox-area text-center" v-if="user_admin">
            <AgentSwitch
              :cropperiodID="cpID"
              :projectDetail="project_detail"
              :cropperiodDetail="cropperiod_detail"
            ></AgentSwitch>
          </div>
          <!-- end 期作計算開關 Agent Switch -->
        </b-col>

        <b-col md="8" v-if="tab_create && cropperiod_list_key != 'cropperiods'">
          <!-- 如果不是 farming 狀態就不顯示建立新期作的填寫內容 -->
        </b-col>
        <b-col md="8" v-else-if="tab_create && !checkCreatable">
          <!-- 如果已達上限就顯示洽談資訊 -->
          <h2>
            <i
              class="fa fa-warning faa-flash animated block-text-sm err-msg"
            ></i
            >進行中期作已達上限數量： {{ cropperiod_max_limit }}
          </h2>
          <br />
          <h3>
            欲增加更多期作請將
            <span class="agri-color-sub">已結束期作</span> 的狀態設定為完成
            (封存)
          </h3>
          <br />
          <br />
          <br />
          <h5 class="agri-color">
            <i class="fa fa-credit-card-alt faa-tada animated block-text-sm"></i
            >增加進行中期作的上限數量請洽阿龜微氣候：
          </h5>
          <h5 class="agri-color">
            林泰佑 York Lin ( york<i class="fa fa-at"></i>beehivedt.com )
          </h5>
        </b-col>
        <b-col md="8" v-else>
          <!-- 期作資訊 -->
          <div class="proj-toolbox-area">
            <h4>
              {{ $t("menu.cropping_season_information") }}
              <div
                class="block-text text-muted"
                v-if="user_admin && tab_create == false"
              >
                ( {{ $t("n.cropping_season") }} ID = {{ cropInfo.id }} )
              </div>
            </h4>
            <p class="text-muted" v-text="$t('other.input_required')">
              * 為必填項目
            </p>
            <b-form>
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="icon-pencil"></i
                    >{{ $t("menu.name") }} *</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model.trim="cropInfo.name"
                  :maxlength="
                    $tools.input.getInputMaxLength('cropperiod', 'name')
                  "
                  aria-describedby="inputLiveFeedback_name"
                  :state="$tools.input.checkRequired(cropInfo.name)"
                />
                <b-form-invalid-feedback id="inputLiveFeedback_name">
                  Enter at least 4 letters
                </b-form-invalid-feedback>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="icon-menu"></i
                    >{{ $t("menu.description") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-textarea
                  type="text"
                  v-model="cropInfo.description"
                  :rows="3"
                  :max-rows="6"
                ></b-form-textarea>
              </b-input-group>

              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="cui-dashboard"></i
                    >{{ $t("n.field") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control"
                  v-model.trim="cropInfo.farm_field"
                  :maxlength="
                    $tools.input.getInputMaxLength('cropperiod', 'farm_field')
                  "
                />
              </b-input-group>

              <!-- 作物 -->
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa fa-leaf"></i
                    >{{ $t("n.crop") }} *</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-select
                  v-if="user_admin || tab_create"
                  v-model="crop_code"
                  :options="list_crops"
                  :select-size="4"
                ></b-form-select>
                <b-form-select
                  v-else
                  :value="crop_code"
                  :options="getCropOptions_not_admin()"
                  :disabled="true"
                ></b-form-select>
              </b-input-group>

              <!-- 品種 -->
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa fa-leaf"></i
                    >{{ $t("n.variety") }} *</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-select
                  v-if="user_admin || tab_create"
                  v-model="crop_info_id"
                  :options="list_cultivars"
                  :select-size="4"
                ></b-form-select>
                <b-form-select
                  v-else
                  :value="crop_info_id"
                  :options="getCropOptions_not_admin(crop_info_id)"
                  :disabled="true"
                ></b-form-select>
              </b-input-group>

              <!-- 時區 -->
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="fa fa-clock-o"></i>{{ $t("menu.timezone") }}
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  class="form-control input-timezone"
                  :value="proj.timezone"
                  :disabled="true"
                />
              </b-input-group>

              <!-- 開始日期 -->
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="fa fa-calendar"></i
                    >{{ $t("menu.planting_day") }} *
                  </b-input-group-text>
                </b-input-group-prepend>
                <!-- New, Admin -->
                <div v-if="tab_create">
                  <date-picker
                    v-model="cropInfo.start_date"
                    :lang="$tools.lang.date_picker(language)"
                    :clearable="false"
                    :width="'100%'"
                    :placeholder="$t('menu.select_date')"
                    format="YYYY-MM-DD"
                  ></date-picker>
                </div>
                <!-- Project Admin -->
                <b-form-input
                  v-else
                  type="text"
                  class="form-control"
                  :value="cropInfo.start_date"
                  style="max-width: 205px"
                  :disabled="true"
                />
              </b-input-group>

              <!-- 面積、單位密度 -->
              <UnitEditorArea
                :area="cropInfo.area"
                :density="cropInfo.density"
                defaultUnit="m2"
                :timezone="cropInfo.project_timezone"
                @update-area="cropInfo.area_default_unit = $event"
                @update-density="cropInfo.density_default_unit = $event"
                pageType="cropperiod"
              ></UnitEditorArea>

              <br />

              <!-- Admin 資訊 -->
              <div class="proj-toolbox-area" v-if="user_admin">
                <h4>Admin Tools</h4>

                <!-- 備註 -->
                <div>
                  <br />
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text
                        ><i class="icon-menu"></i
                        >{{ $t("menu.admin_note") }}</b-input-group-text
                      >
                    </b-input-group-prepend>
                    <b-form-textarea
                      type="text"
                      v-model="cropInfo.note"
                      :rows="1"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-input-group>
                </div>
              </div>
              <!-- end Admin 專案資訊 -->

              <br />

              <!-- Create New 期作資訊 -->
              <div v-if="tab_create" class="text-center">
                <b-button
                  variant="danger"
                  class="px-4 btn-upload btn-red"
                  @click="edit_confirm('create')"
                  :disabled="uploading || checkDisabled"
                >
                  <i class="fa fa-plus"></i>{{ $t("menu.new_cropping_season") }}
                </b-button>
                <br /><br />
                <div class="err-msg">
                  {{ $t("other.conform_create_cropperiod") }}
                </div>
                <br />
              </div>
              <!-- end Create New 期作資訊 -->

              <!-- Edit 期作資訊 -->
              <div v-else>
                <div class="text-center">
                  <b-button
                    variant="success"
                    class="px-4 btn-upload"
                    v-text="$t('menu.save_changes')"
                    @click="upload_cropInfo"
                    :disabled="uploading || checkDisabled"
                    >儲存變更</b-button
                  >

                  <b-button
                    variant="danger"
                    class="px-4 btn-upload btn-red"
                    v-if="checkCreatable"
                    @click="clone_cropInfo"
                    :disabled="uploading"
                  >
                    <i class="fa fa-plus"></i
                    >{{ $t("menu.clone_as_new_cropping_season") }}
                  </b-button>
                </div>
              </div>
              <!-- end Edit 期作資訊 -->
            </b-form>
          </div>
          <!-- end 期作資訊 -->

          <!-- 狀態更改工具 -->
          <div class="proj-toolbox-area" v-if="tab_create == false">
            <h4>{{ $t("n.cropping_season") }} {{ $t("menu.status") }}</h4>

            <!-- 期作狀態： -->
            <div v-if="cropInfo.status">
              <b-input-group class="mb-3">
                <b-input-group-prepend>
                  <b-input-group-text
                    ><i class="fa fa-calendar-check-o"></i
                    >{{ $t("n.cropping_season") }}
                    {{ $t("menu.status") }}</b-input-group-text
                  >
                </b-input-group-prepend>
                <b-form-radio-group
                  v-model="cropInfo.status"
                  :plain="true"
                  buttons
                >
                  <template
                    v-for="(status, idx_status) in cropperiod_status_List"
                  >
                    <b-form-radio
                      v-if="cropInfo.status == status.value"
                      :key="idx_status"
                      :value="status.value"
                      :button-variant="status.buttonVariant"
                    >
                      {{ $t("status.cropperiod." + status.value) }}
                    </b-form-radio>
                  </template>
                </b-form-radio-group>
              </b-input-group>
            </div>

            <!-- 結束期作：設定日期後確認更新 -->
            <div v-if="cropInfo.status != 'done'">
              <div class="block-text">
                <b-input-group class="mb-3" v-if="tab_create == false">
                  <b-input-group-prepend>
                    <b-input-group-text>
                      <i class="fa fa-calendar"></i>{{ $t("menu.end_date") }}
                    </b-input-group-text>
                  </b-input-group-prepend>
                  <div>
                    <date-picker
                      v-model="cropInfo.end_date"
                      :lang="$tools.lang.date_picker(language)"
                      :width="'100%'"
                      :placeholder="$t('menu.select_date')"
                      :not-before="cropInfo.start_date"
                      :not-after="date_today"
                      format="YYYY-MM-DD"
                    ></date-picker>
                  </div>
                </b-input-group>
              </div>
              <div class="block-text">
                <b-button
                  variant="success"
                  class="px-4 btn-upload"
                  v-text="$t('menu.done_cropping_season')"
                  @click="edit_confirm('done')"
                  :disabled="uploading || checkDoneable"
                ></b-button>
              </div>
              <div class="agri-color">
                {{ $t("other.confirm_done_cropperiod_2") }}
              </div>
            </div>

            <br /><br />

            <div class="text-center">
              <b-button
                id="button-DeleteCropperiod"
                variant="dark"
                class="px-4 btn-upload"
                @click="edit_confirm('delete')"
                :disabled="uploading"
              >
                <i class="fa fa-trash-o"></i
                >{{ $t("menu.delete_cropping_season") }}
              </b-button>

              <div
                v-if="user_admin"
                class="block-text"
                v-b-tooltip
                title="Admin Tools"
              >
                <div class="block-text" v-if="cropInfo.status != 'farming'">
                  <b-button
                    class="px-4 btn-upload btn-red"
                    variant="danger"
                    @click="upload_cropInfo('status', 'farming')"
                  >
                    將狀態改回 【 {{ $t("status.cropperiod.farming") }} 】
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-col> </b-row
      ><!-- end b-row -->

      <b-row>
        <b-col md="12">
          <!-- 期作下感測器名稱&描述 -->
          <div
            class="proj-toolbox-area"
            v-if="tab_create == false && (user_admin || project_editable)"
          >
            <h4 v-text="$t('menu.device_information')"></h4>

            <EditCropperiodDevices
              :cropperiodID="this.cpID"
            ></EditCropperiodDevices>
          </div>
          <!-- end 期作下感測器名稱&描述 -->
        </b-col> </b-row
      ><!-- end b-row -->
    </div>

    <!-- Modal: confirm delete -->
    <b-modal
      v-model="confirm_show_modal"
      :title="conform_title"
      header-bg-variant="primary"
      hide-header-close
      hide-footer
    >
      <div class="list-edit-area-modal-body">
        <div v-if="confirm_action == 'create'">
          {{ $t("other.conform_create_cropperiod") }}
        </div>
        <div v-else-if="confirm_action == 'done'">
          {{ $t("other.confirm_done_cropperiod") }}
          <br /><br />
          {{ $t("other.confirm_done_cropperiod_2") }}
        </div>
        <div v-else-if="confirm_action == 'delete'">
          {{ $t("other.confirm_delete_cropperiod") }}
        </div>
      </div>

      <div class="list-edit-area-modal-body">
        <h4>{{ $t("other.enter_confirmation_code") }}：{{ confirm_text }}</h4>
        <b-form-input
          type="text"
          :placeholder="$t('other.enter_confirmation_code')"
          v-model="confirm_answer"
        ></b-form-input>
      </div>

      <div class="text-center">
        <button
          type="button"
          class="btn btn-secondary btn-upload"
          @click.prevent="confirm_show_modal = false"
          :disabled="uploading"
        >
          <i class="fa fa-close"></i> {{ $t("menu.cancel") }}
        </button>

        <b-button
          v-if="confirm_action == 'create'"
          variant="danger"
          class="px-4 btn-upload"
          @click="create_cropInfo()"
          :disabled="confirm_text != confirm_answer"
        >
          {{ $t("menu.new_cropping_season") }}
        </b-button>
        <b-button
          v-if="confirm_action == 'done'"
          variant="danger"
          class="px-4 btn-upload"
          @click="delete_cropInfo('done')"
          :disabled="confirm_text != confirm_answer"
        >
          {{ $t("menu.done_cropping_season") }}
        </b-button>
        <b-button
          v-if="confirm_action == 'delete'"
          variant="danger"
          class="px-4 btn-upload"
          @click="delete_cropInfo('delete')"
          :disabled="confirm_text != confirm_answer"
        >
          {{ $t("menu.delete_cropping_season") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import TestData from "@/testData/testData";
import VueCropper from "vue-cropperjs";
import FileUpload from "vue-upload-component";
import { mapState } from "vuex";
import EditCropperiodDevices from "@/views/device/Edit_Cropperiod_Devices";
import UnitEditorArea from "@/views/components/UnitEditor_Area";
import AgentSwitch from "@/views/project/management/components/AgentSwitch";
import PublicToolsSwitch from "@/views/project/management/components/PublicToolsSwitch";
import DatePicker from "vue2-datepicker";

export default {
  name: "cropperiodManagement",
  components: {
    FileUpload,
    EditCropperiodDevices,
    DatePicker,
    UnitEditorArea,
    AgentSwitch,
    PublicToolsSwitch,
  },
  data: function () {
    return {
      tabIndex: 1,
      tab_create: false,
      tab_clone: false,

      pic_preview: undefined,
      pic_files: [],
      KML_file: undefined,

      edit: {
        pic: false,
      },
      uploading: false,

      cropperiod_edit_id: undefined,
      cropperiod_list_key: "cropperiods",
      cropperiod_max_limit: 3,
      crop_info_id: undefined,
      crop_code: undefined,
      cropInfo: {
        id: undefined,
        pic: undefined,
        name: "",
        description: "",
        farm_field: "",

        weather_location: "",

        area: undefined,
        density: undefined,
        area_default_unit: undefined,
        density_default_unit: undefined,

        // New / Edit by Admin
        start_date: undefined,
        end_date: undefined,
        status: "",
        note: undefined,
      },

      // confirm
      confirm_show_modal: false,
      conform_title: "",
      confirm_text: "",
      confirm_answer: "",
      confirm_action: undefined,
    };
  },
  // 在 router 改變、vue 頁面更新後處理：頁面網址數值變更自動執行
  beforeRouteUpdate(to, from, next) {
    // console.log(to.params.projectID + ' ?' + Math.random());

    // 根據網址判斷要編輯的是哪個狀態的期作清單
    this.checkEditMode(to, from, next);
  },
  mounted() {
    // 根據網址判斷要編輯的是哪個狀態的期作清單
    this.checkEditMode(this.$route, undefined, undefined);

    this.get_CropInfo();
  },
  computed: {
    ...mapState({
      user_admin: (state) => state.user.is_admin,
      projects: (state) => state.project.projects,
      project_detail: (state) => state.project.project_detail,
      project_timezone: (state) => state.project.project_timezone,
      project_editable: (state) => state.project.project_editable,
      cropperiod_detail: (state) => state.cropperiod.cropperiod,
      cropperiod_status_List: (state) => state.cropperiod.list_status,

      language: (state) => state.user.language,
      list_crops: (state) => state.cropperiod.list_crops,
      list_cultivars: (state) => state.cropperiod.list_cultivars,
    }),

    proj() {
      return this.project_detail;
    },

    projID() {
      return this.$route.params.projectID;
    },

    // 取得當下 tab 對應到的期作 ID
    cpID() {
      if (this.$route.query.edit != undefined) {
        // 檢查是否是此專案下的期作
        this.cropperiod_edit_id = undefined;
        let _cps = this.project_detail[this.cropperiod_list_key];

        _cps.forEach((_cp) => {
          if (_cp.id == this.$route.query.edit)
            this.cropperiod_edit_id = _cp.id;
        });
      }

      let _idx = this.tabIndex - 1;
      this.tab_create = false;

      if (this.tabIndex == 0) {
        this.tab_create = true;
      } else if (
        _idx >= 0 &&
        this.project_detail[this.cropperiod_list_key][_idx]
      ) {
        return this.project_detail[this.cropperiod_list_key][_idx].id;
      }
      return undefined;
    },

    date_today() {
      if (this.project_detail) {
        return this.$tools.date.getDateNow(
          this.project_detail.timezone,
          "YYYY-MM-DD"
        );
      }
      return this.$tools.date.getDateNow("UTC", "YYYY-MM-DD");
    },

    checkDisabled() {
      if (this.$tools.input.checkRequired(this.cropInfo.name) == false)
        return true;

      if (this.crop_info_id == undefined) return true;
      if (this.crop_code == undefined) return true;
      if (
        this.cropInfo.start_date == undefined ||
        this.cropInfo.start_date == ""
      )
        return true;
      return false;
    },

    checkCreatable() {
      if (this.proj) {
        if (this.proj.cropperiods.length < this.cropperiod_max_limit) {
          return true;
        }
      }
      return false;
    },

    checkDoneable() {
      if (this.cropInfo.end_date == undefined) return true;
      return false;
    },
  },
  watch: {
    pic_files() {
      if (this.pic_files.length > 0) {
        this.pic_preview = this.pic_files[0].url;
      }
    },

    tabIndex() {
      this.getCropperiod(this.cpID);
    },

    // 偵測到 [ 語言 ] 變動就更新作物清單
    language() {
      this.get_CropInfo();
      this.get_CropInfo(this.crop_code);
    },

    crop_code(val, oldVal) {
      if (oldVal) {
        this.crop_info_id = undefined;
      }

      this.get_CropInfo(this.crop_code);
    },
  },
  methods: {
    modal_init(action = undefined) {
      this.confirm_show_modal = false;
      this.confirm_text = this.$tools.input.randomCode();
      this.confirm_answer = "";
      this.confirm_action = action;
      if (action == "create") {
        this.conform_title =
          this.$t("menu.new_cropping_season") +
          "： " +
          (this.cropInfo ? this.cropInfo.name : "");
      } else if (action == "done") {
        this.conform_title =
          this.$t("menu.done_cropping_season") +
          "： " +
          (this.cropperiod_detail ? this.cropperiod_detail.name : "");
      } else if (action == "delete") {
        this.conform_title =
          this.$t("menu.delete_cropping_season") +
          "： " +
          (this.cropperiod_detail ? this.cropperiod_detail.name : "");
      }
    },
    edit_confirm(action) {
      this.modal_init(action);
      this.confirm_show_modal = true;
    },

    checkEditMode(to = undefined, from = undefined, next = undefined) {
      // console.log( 'to: ' + to.path )

      let _query = to != undefined ? to.query : {};
      // 根據網址判斷要編輯的是哪個狀態的期作清單
      this.cropperiod_edit_id = undefined;
      if (_query.edit != undefined) {
        this.cropperiod_edit_id = _query.edit;
      }
      if (this.user_admin == false) {
        this.cropperiod_list_key = "cropperiods";
      } else if (_query.list == "done") {
        this.cropperiod_list_key = "done_cropperiods";
      } else if (_query.list == "abandon") {
        this.cropperiod_list_key = "abandon_cropperiods";
      } else {
        this.cropperiod_list_key = "cropperiods";
      }

      this.getProject(to, from, next);
    },

    // 非 Admin 的人在編輯期作時是不能切換作物的，故只顯示已選擇的項目
    getCropOptions_not_admin(cropCode = undefined) {
      let _cropText = "";
      let _cropNow = undefined;

      if (cropCode) {
        _cropNow = this.list_cultivars.find(
          (_crop) => _crop.value === this.crop_info_id
        );
      } else {
        _cropNow = this.list_crops.find(
          (_crop) => _crop.value === this.crop_code
        );
      }

      if (_cropNow) {
        // console.log( _cropNow.text )
        return [_cropNow];
      }
      return [];
    },

    // 取得專案資料
    getProject(to = undefined, from = undefined, next = undefined) {
      // console.log('projID');
      // console.log(this.projID + ' ?' + Math.random());
      let _projID = next ? to.params.projectID : this.projID;
      // console.log(_projID);

      this.$store
        .dispatch("project/getProjectDetail", _projID)
        .then((res) => {
          if (this.project_detail.editable || this.user_admin) {
            if (this.project_detail.cropperiod_max_limit) {
              this.cropperiod_max_limit =
                this.project_detail.cropperiod_max_limit;
            } else {
              this.cropperiod_max_limit = 3;
            }

            if (this.project_detail[this.cropperiod_list_key].length > 0) {
              this.getCropperiod(this.cpID);

              // 取得所屬此專案的所有裝置
              this.getProjectDevices(_projID);
            } else {
              this.clear_cropInfo();
            }

            if (next) next();
          } else {
            this.$router.push({
              name: "Page403",
            }); // 導向 403
          }
        })
        .catch((err) => {});
    },
    // 取得期作資料
    getCropperiod(cropperiodID) {
      // console.log(this.cpID + ' ?' + Math.random());
      if (cropperiodID) {
        this.$store
          .dispatch("cropperiod/getCropperiod", cropperiodID)
          .then((res) => {
            this.reset_imagePreview();
            this.set_cropInfo();
          })
          .catch((err) => {});
      } else {
        this.clear_cropInfo();
      }
    },

    getProjectDevices(_projectID) {
      this.$store
        .dispatch("project/getProjectDevices", _projectID)
        .then((res) => {})
        .catch((err) => {});
    },

    // 清除介面上上的填寫資料 for Create New 期作用
    clear_cropInfo() {
      // New / Edit by Admin
      (this.cropInfo.start_date = this.$tools.date.getDateNow(
        this.project_timezone,
        "YYYY-MM-DD"
      )),
        (this.cropInfo.end_date = undefined);
      this.cropInfo.status = this.cropperiod_status_List[0].value; // 'farming'

      if (this.tab_clone == false) {
        this.cropInfo.id = undefined;
        this.cropInfo.name = "";
        this.cropInfo.description = "";

        this.crop_code = undefined;
        this.crop_info_id = undefined;

        this.cropInfo.weather_location = "";

        this.cropInfo.area = undefined;
        this.cropInfo.density = undefined;
        this.cropInfo.area_default_unit = undefined;
        this.cropInfo.density_default_unit = undefined;

        this.cropInfo.farm_field = undefined;
        this.cropInfo.pic = undefined;
        this.cropInfo.note = undefined;

        this.reset_files("KML");
        this.reset_imagePreview(true);
      }

      this.tab_clone = false;
    },

    // 更新介面上的專案資料
    set_cropInfo(_clone = false) {
      this.cropInfo.id = this.cropperiod_detail.id;
      this.cropInfo.name = this.cropperiod_detail.name;
      this.cropInfo.description = this.cropperiod_detail.description;

      this.crop_code = this.cropperiod_detail.cropinfo.crop_code;
      // this.crop_info_id         = this.cropperiod_detail.cropinfo.id

      this.cropInfo.weather_location = this.cropperiod_detail.weather_location;

      this.cropInfo.area = this.cropperiod_detail.area;
      this.cropInfo.density = this.cropperiod_detail.density;
      this.cropInfo.area_default_unit = this.cropperiod_detail.area;
      this.cropInfo.density_default_unit = this.cropperiod_detail.density;

      this.cropInfo.farm_field = this.cropperiod_detail.farm_field;
      this.cropInfo.pic = this.cropperiod_detail.pic;

      // New / Edit by Admin
      if (_clone) {
        // 複製期作的情況下，以下數值不複製
        this.cropInfo.name += " - copy";
        this.cropInfo.start_date = this.$tools.date.getDateNow(
          this.project_timezone,
          "YYYY-MM-DD"
        );
        this.cropInfo.end_date = undefined;
        this.cropInfo.status = this.cropperiod_status_List[0].value; // 'farming'
        this.cropInfo.note = `#${this.cropInfo.start_date} - cloned from [ ${this.cropperiod_detail.name} ](ID=${this.cropperiod_detail.id})`;
      } else {
        this.cropInfo.start_date = this.cropperiod_detail.start_date;
        this.cropInfo.end_date = this.cropperiod_detail.end_date;
        this.cropInfo.status = this.cropperiod_detail.status;
        this.cropInfo.note = this.cropperiod_detail.note;
      }

      if (this.cropInfo.status == undefined) {
        this.cropInfo.status = this.cropperiod_status_List[0].value;
      }

      this.reset_files("KML");
      this.uploading = false;
    },

    // 複製當下期作資訊到 Create New 期作的 tab
    clone_cropInfo() {
      this.tabIndex = 0;
      this.tab_clone = true;
      this.set_cropInfo(true);
    },

    // 刪除當下期作資訊：其實只是把狀態改為 done，並隱藏起來
    delete_cropInfo(action = "delete") {
      this.confirm_show_modal = false;
      this.uploading = true;
      let _url_params = { cropperiodID: this.cropInfo.id };

      if (action == "delete") {
        _url_params.status = "abandon";
        _url_params.end_date = this.$tools.date.getDateNow(
          "UTC",
          "YYYY-MM-DD HH:mm:ss"
        ); // 刪除當天的 UTC time
      } else if (action == "done") {
        _url_params.status = "done";
        _url_params.end_date = this.$tools.date.dataTimeZone_to_UTC(
          this.cropInfo.end_date,
          this.proj.timezone
        ); // 轉成 UTC time
      }

      const options = {
        method: "DELETE",
        url: this.$config.getAPI_URL("Status_Cropperiod", _url_params),
      };
      this.$http(options)
        .then((res) => {
          this.getProject();
          this.$tools.ui.updateSideBar(this);
          this.$toastr.s(this.$t("other.update_succeeded"), "");
        })
        .catch((err) => {
          this.uploading = false;
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            ""
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "delete",
        detail: {
          page: "cropperiod",
          action: "set status",
          querySettings: {
            "cropperiod ID": this.cropInfo.id,
            "cropperiod name": this.cropInfo.name,
            "cropperiod status":
              this.cropInfo.status + " => " + _url_params.status,
            "cropperiod end date": _url_params.end_date,
          },
          pageInfo: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "user role": this.cropperiod_detail.project_role,
            "project status": this.cropperiod_detail.project_status,
            "service level": this.cropperiod_detail.project_service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 上傳並更新專案基礎資訊
    upload_cropInfo(action = undefined, value = undefined) {
      this.confirm_show_modal = false;
      this.uploading = true;
      let _data = {
        name: this.cropInfo.name,
        crop_info_id: this.crop_info_id,
        status: this.cropInfo.status,

        // nullable
        description: this.cropInfo.description,
        area: this.cropInfo.area_default_unit,
        density: this.cropInfo.density_default_unit,
        farm_field: this.cropInfo.farm_field,
      };

      this.cropInfo.area = undefined; // 清除輸入介面 - 面積
      this.cropInfo.density = undefined; // 清除輸入介面 - 密度

      if (this.cropInfo.end_date) {
        _data.end_date = this.$tools.date.dataTimeZone_to_UTC(
          this.cropInfo.end_date,
          this.proj.timezone
        );
      } // 轉成 UTC time
      else {
        _data.end_date = undefined;
      }
      // // if (this.cropInfo.weather_location)     { _data.weather_location = this.cropInfo.weather_location; }

      let _url = "";

      if (this.user_admin) {
        _url = this.$config.getAPI_URL("Update_Cropperiod", {
          cropperiodID: this.cropInfo.id,
        });
        _data.start_date = this.$tools.date.dataTimeZone_to_UTC(
          this.cropInfo.start_date,
          this.proj.timezone
        ); // 轉成 UTC time
        _data.note = this.cropInfo.note;
      } else {
        _url = this.$config.getAPI_URL("Update_Cropperiod", {
          cropperiodID: this.cropInfo.id,
        });
      }

      // 只更新狀態
      if (action == "status" && value != undefined) {
        _data = {
          status: value,
          end_date: null, // 因為 done 和 abandon 走另一個 API，故改變狀態就把 end_date 清掉
        };
      }

      const options = {
        method: "PUT",
        url: _url,
        data: _data,
      };
      this.$http(options)
        .then((res) => {
          // this.getCropperiod(this.cropInfo.id);
          this.getProject();
          this.$tools.ui.updateSideBar(this);
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.cropping_season_information")
          );
        })
        .catch((err) => {
          this.uploading = false;
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            this.$t("menu.cropping_season_information")
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "update info",
          querySettings: {
            "cropperiod ID": this.cropInfo.id,
            "cropperiod name": this.cropInfo.name,
            "cropperiod status": this.cropInfo.status,
          },
          pageInfo: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "is admin": this.user_admin,
            "user role": this.project_detail.role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 上傳並更新專案基礎資訊
    create_cropInfo() {
      this.confirm_show_modal = false;
      this.uploading = true;

      let _data = {
        name: this.cropInfo.name,
        crop_info_id: this.crop_info_id,

        start_date: this.$tools.date.dataTimeZone_to_UTC(
          this.cropInfo.start_date,
          this.proj.timezone
        ), // 轉成 UTC time
        status: this.cropInfo.status,
        note: this.cropInfo.note,
      };

      // 非必填欄位
      this.cropInfo.area = undefined; // 清除輸入介面 - 面積
      this.cropInfo.density = undefined; // 清除輸入介面 - 密度
      if (this.cropInfo.area_default_unit) {
        _data.area = this.cropInfo.area_default_unit;
      }
      if (this.cropInfo.density_default_unit) {
        _data.density = this.cropInfo.density_default_unit;
      }
      if (this.cropInfo.pic) {
        _data.pic = this.cropInfo.pic;
      }
      if (this.cropInfo.description) {
        _data.description = this.cropInfo.description;
      }
      if (this.cropInfo.farm_field) {
        _data.farm_field = this.cropInfo.farm_field;
      }
      if (this.cropInfo.end_date) {
        _data.end_date = this.$tools.date.dataTimeZone_to_UTC(
          this.cropInfo.end_date,
          this.proj.timezone
        );
      } // 轉成 UTC time
      // if (this.cropInfo.weather_location)     { _data.weather_location = this.cropInfo.weather_location; }

      const options = {
        method: "POST",
        url: this.$config.getAPI_URL("Create_Cropperiod", {
          projectID: this.project_detail.id,
        }),
        data: _data,
      };
      this.$http(options)
        .then((res) => {
          // this.getCropperiod(this.cropInfo.id);
          this.getProject();
          this.$tools.ui.updateSideBar(this);
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("menu.cropping_season_information")
          );
          this.uploading = false;
        })
        .catch((err) => {
          // console.log(options);
          // console.log(err);
          this.uploading = false;
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            this.$t("menu.cropping_season_information")
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "create cropperiod",
          querySettings: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "cropperiod name": this.cropInfo.name,
            "cropperiod status": this.cropInfo.status,
          },
          pageInfo: {
            "is admin": this.user_admin,
            "user role": this.project_detail.role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 上傳地圖邊界 KML
    upload_files(type) {
      this.uploading = true;

      if (type == "KML") {
        let _formData = new FormData();
        _formData.append("boun", this.KML_file);

        const uploadData = {
          id: this.cpID,
          formData: _formData,
        };
        this.$store
          .dispatch("cropperiod/uploadBoundary", uploadData)
          .then((res) => {
            this.uploading = false;
            this.$toastr.s(
              this.$t("other.update_succeeded"),
              this.$t("n.cropping_season") + " " + this.$t("menu.map_boundary")
            );
          })
          .catch((err) => {
            this.uploading = false;
            this.$toastr.e(
              this.$t("other.update_failed") +
                "<br>" +
                err.data.status +
                "<br>" +
                err.data.message,
              this.$t("n.cropping_season") + " " + this.$t("menu.map_boundary")
            );
          });

        // 送出使用者操作紀錄 --------------------
        let _OPLog = {
          user_id: this.$store.state.user.id,
          type: "write",
          detail: {
            page: "cropperiod",
            action: "update boundary",
            querySettings: {
              "cropperiod ID": this.cropInfo.id,
              "cropperiod name": this.cropInfo.name,
              "cropperiod status": this.cropInfo.status,
            },
            pageInfo: {
              "project ID": this.project_detail.id,
              "project name": this.project_detail.name,
              "is admin": this.user_admin,
              "user role": this.project_detail.role,
              "project status": this.project_detail.status,
              "service level": this.project_detail.service_level,
            },
          },
        };
        this.$store
          .dispatch("user/createLog", _OPLog)
          .then((res) => {})
          .catch((err) => {});
        // 送出使用者操作紀錄 --------------------
      }
    },

    // 取得作物&品種清單：
    // 無 cropCode 表示要撈 [ 作物 ] 清單，有 cropCode 表示要撈該作物代碼下的 [ 品種 ] 清單
    get_CropInfo(cropCode = undefined) {
      this.uploading = true;

      this.$store
        .dispatch("cropperiod/getCropInfo", {
          cropCode: cropCode,
          language: this.language,
        })
        .then((res) => {
          this.uploading = false;

          // 編輯：在取得作物品種後才指定選到的品種，介面上才會配對到選擇的品種
          if (cropCode != undefined && this.tab_create == false) {
            this.crop_info_id = this.cropperiod_detail.cropinfo.id;
          }

          // 新增：在取得作物品種後，預設選第一個品種
          if (cropCode != undefined && this.tab_create == true) {
            if (this.list_cultivars && this.list_cultivars.length > 0) {
              this.crop_info_id = this.list_cultivars[0].value;
            }
          }
        })
        .catch((err) => {
          // console.log(err);
          this.uploading = false;
        });
    },

    // 清除選擇檔案的區域
    reset_files(type) {
      if (type == "KML" && this.$refs.fileinput_KML != undefined) {
        this.$refs.fileinput_KML.reset();
      }
    },

    // 上傳更新圖片
    upload_image(type, files) {
      this.uploading = true;

      let _info = {
        uploadType: type,
        cropperiodID: this.cropInfo.id,
        file: files[0].file, // files[0] 為物件，要上傳 File 檔 server 才收
      };

      if (type == "pic") {
        let _oldFile = files[0].file;
        let _fileOptions = {
          maxSize: 2000000, // 2MB
          maxWidth: 1024,
          minWidth: 600,
        };
        let _binStr = atob(
          this.$refs.cropper
            .getCroppedCanvas(_fileOptions)
            .toDataURL(_oldFile.type)
            .split(",")[1]
        );
        let _arr = new Uint8Array(_binStr.length);
        for (let i = 0; i < _binStr.length; i++) {
          _arr[i] = _binStr.charCodeAt(i);
        }
        _info.file = new File([_arr], _oldFile.name, {
          type: _oldFile.type,
        });
      }

      this.$store
        .dispatch("cropperiod/uploadImage", _info)
        .then((res) => {
          //  console.log('上傳成功：');
          // console.log(res);
          this.reset_imagePreview();
          this.$toastr.s(
            this.$t("other.update_succeeded"),
            this.$t("n.cropping_season") + " " + this.$t("menu.picture")
          );
        })
        .catch((err) => {
          // console.log('上傳失敗：err');
          // console.log(err);
          this.reset_imagePreview();
          this.$toastr.e(
            this.$t("other.update_failed") +
              "<br>" +
              err.data.status +
              "<br>" +
              err.data.message,
            this.$t("n.cropping_season") + " " + this.$t("menu.picture")
          );
        });

      // 送出使用者操作紀錄 --------------------
      let _OPLog = {
        user_id: this.$store.state.user.id,
        type: "write",
        detail: {
          page: "cropperiod",
          action: "update pic",
          querySettings: {
            "cropperiod ID": this.cropInfo.id,
            "cropperiod name": this.cropInfo.name,
            "cropperiod status": this.cropInfo.status,
          },
          pageInfo: {
            "project ID": this.project_detail.id,
            "project name": this.project_detail.name,
            "is admin": this.user_admin,
            "user role": this.project_detail.role,
            "project status": this.project_detail.status,
            "service level": this.project_detail.service_level,
          },
        },
      };
      this.$store
        .dispatch("user/createLog", _OPLog)
        .then((res) => {})
        .catch((err) => {});
      // 送出使用者操作紀錄 --------------------
    },

    // 取消圖片預覽
    reset_imagePreview(doCreate = false) {
      this.pic_files = [];
      if (doCreate) this.pic_preview = undefined;
      else this.pic_preview = this.cropperiod_detail.pic;
      this.uploading = false;
    },

    check_inputFile_pic(newFile, oldFile, prevent) {
      this.$tools.input.check_inputFile(newFile, oldFile, prevent, this, "pic");
    },
    image_inputFilter(newFile, oldFile, prevent) {
      this.$tools.input.image_inputFilter(
        newFile,
        oldFile,
        prevent,
        this,
        false
      );
    },
  },
};
</script>

<style lang="scss">
.input-timezone {
  max-width: 250px;
}

.cropperiod-img {
  @media only screen and (min-width: 400px) {
    min-height: 250px;
  }

  @media only screen and (min-width: 550px) {
    min-height: 320px;
  }

  @media only screen and (min-width: 750px) {
    min-height: 250px;
  }
}

.toolbox-pic {
  display: inline-block;
  width: 100%;
}

.toolbox-pic-edit {
  width: 100%;
}
</style>
